<template>
    <section class="features" id="features">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">Nos solutions financières complètes</h2>
          <p class="section-subtitle">Découvrez comment Oasis peut vous accompagner dans tous vos projets financiers</p>
          
          <div class="intro-text">
            <p>Chez Oasis Microfinance, nous croyons que chaque individu et chaque entreprise mérite un accès simple et équitable à des solutions financières adaptées. Notre approche combine innovation technologique et expertise humaine pour vous offrir des services sur mesure.</p>
            <p>Que vous soyez un particulier souhaitant financer un projet personnel, un entrepreneur cherchant à développer votre activité, ou un épargnant désirant faire fructifier votre capital, nos solutions sont conçues pour répondre précisément à vos besoins.</p>
          </div>
          
          <div class="divider"></div>
        </div>
        
        <div class="features-grid">
          <div class="feature-card" v-for="(feature, index) in features" :key="index">
            <div class="feature-icon">
              <span class="icon-bg"></span>
              <span class="icon-number">0{{ index + 1 }}</span>
            </div>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
            <ul class="feature-benefits">
              <li v-for="(benefit, i) in feature.benefits" :key="i">
                <svg viewBox="0 0 24 24" width="18" height="18">
                  <path fill="#1cc48d" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                </svg>
                {{ benefit }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'FeaturesSection',
    data() {
      return {
        features: [
          {
            title: "Prêts personnels",
            description: "Financez vos projets personnels avec des conditions adaptées",
            benefits: [
              "Montant jusqu'à 5 000 000 FCFA",
              "Taux compétitifs",
              "Remboursement sur 12 à 36 mois"
            ]
          },
          {
            title: "Microcrédit professionnel",
            description: "Développez votre entreprise avec notre soutien financier",
            benefits: [
              "Décision rapide sous 24h",
              "Accompagnement personnalisé",
              "Sans garantie lourde"
            ]
          },
          {
            title: "Épargne sécurisée",
            description: "Faites fructifier votre argent en toute sécurité",
            benefits: [
              "Comptes rémunérés",
              "Produits d'épargne flexibles",
              "Rendements attractifs"
            ]
          },
          {
            title: "Crédit immobilier",
            description: "Accédez à la propriété dans les meilleures conditions",
            benefits: [
              "Financement jusqu'à 80% du projet",
              "Durée jusqu'à 20 ans",
              "Taux fixes avantageux"
            ]
          },
          {
            title: "Assurance crédit",
            description: "Protégez-vous contre les aléas de la vie",
            benefits: [
              "Couverture invalidité/décès",
              "Protection chômage",
              "Prime compétitive"
            ]
          },
          {
            title: "Comptes professionnels",
            description: "Solutions bancaires pour votre entreprise",
            benefits: [
              "Gestion de trésorerie",
              "Services en ligne complets",
              "Cartes bancaires professionnelles"
            ]
          },
          {
            title: "Financement agricole",
            description: "Spécialement conçu pour le secteur agricole",
            benefits: [
              "Calendrier adapté aux récoltes",
              "Expertise sectorielle",
              "Saisonniers ou permanents"
            ]
          },
          {
            title: "Formation financière",
            description: "Renforcez vos connaissances financières",
            benefits: [
              "Ateliers gratuits",
              "Conseils personnalisés",
              "Gestion de budget"
            ]
          },
          {
            title: "Transferts internationaux",
            description: "Envoyez et recevez de l'argent à l'étranger",
            benefits: [
              "Taux compétitifs",
              "Réseau international",
              "Transactions sécurisées"
            ]
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .features {
    padding: 5rem 1rem;
    background: #f9f9f9;
    position: relative;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .section-header {
    text-align: center;
    margin-bottom: 3rem;
  }
  
  .section-title {
    font-size: 2.2rem;
    color: #0a2e38;
    margin-bottom: 1.5rem;
    position: relative;
    display: inline-block;
  }
  
  .section-title::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #1cc48d;
  }
  
  .section-subtitle {
    font-size: 1.1rem;
    color: #5a6f7b;
    max-width: 700px;
    margin: 0 auto 1.5rem;
    font-weight: 500;
  }
  
  .intro-text {
    max-width: 800px;
    margin: 0 auto 2rem;
    text-align: center;
  }
  
  .intro-text p {
    color: #5a6f7b;
    line-height: 1.7;
    margin-bottom: 1.2rem;
    font-size: 1.05rem;
  }
  
  .divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent);
    max-width: 800px;
    margin: 2rem auto;
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .feature-card {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    z-index: 1;
  }
  
  .feature-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, #1cc48d, #0f4c75);
    transition: height 0.3s ease;
  }
  
  .feature-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  }
  
  .feature-card:hover::before {
    height: 10px;
  }
  
  .feature-icon {
    position: relative;
    width: 60px;
    height: 60px;
    margin-bottom: 1.5rem;
  }
  
  .icon-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(28, 196, 141, 0.1);
    border-radius: 50%;
    animation: pulse 3s infinite ease-in-out;
  }
  
  .icon-number {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 700;
    color: #1cc48d;
  }
  
  .feature-card h3 {
    font-size: 1.4rem;
    color: #0a2e38;
    margin-bottom: 1rem;
  }
  
  .feature-card p {
    color: #5a6f7b;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
  
  .feature-benefits {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .feature-benefits li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.8rem;
    color: #0a2e38;
    font-size: 0.95rem;
  }
  
  @keyframes pulse {
    0% { transform: scale(1); opacity: 0.7; }
    50% { transform: scale(1.05); opacity: 0.9; }
    100% { transform: scale(1); opacity: 0.7; }
  }
  
  @media (max-width: 768px) {
    .features {
      padding: 3rem 1rem;
    }
    
    .section-title {
      font-size: 1.8rem;
    }
    
    .features-grid {
      grid-template-columns: 1fr;
    }
    
    .intro-text p {
      font-size: 1rem;
      text-align: left;
    }
  }
  </style>